import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
// import { CreateExam } from './CreateExam';
// import { DeleteExam } from './DeleteExam';
// import { UpdateExam } from './UpdateExam';
import { CreateExamMicrobiology } from './CreateExamMicrobiology';
import { DeleteExamMicrobiology } from './DeleteExamMicrobiology';
import { UpdateExamMicrobiology } from './UpdateExamMicrobiology';
import { Dialog } from 'primereact/dialog';

export const ModalExamMicrobiology = (props) => {

    const {

        formValues,
        method, handleInputChange, validaciones,
        sections, id_format_sanitary, formats, specimenOrigins, subSections, commercialLines, specimens, specimenProvenances, typeTransports, transports,
        id_section, id_subsection, id_specimen_origin, code, alias, name, abbreviation, individual_sale, cost, is_referenced, is_critic,
        closeDialog, modal, modalTitle, loading, listExternalLaboratories, examId, getUpdateDefaultExternalLaboratory,
        changeSelect, handleSelectValues,
        saveCreate,
        saveUpdate,
        saveDelete,
        handleChangePrice, isImagenologyy, use_antibiogram, print_new_page
    } = props;

    //console.log(props, "props del modal")

    return (
       <Dialog
            header={modalTitle}
            visible={modal}
            modal
            dismissableMask
            onHide={closeDialog}
           className='large-dialog'
        >
            {method === "create" ? (
                <CreateExamMicrobiology
                    {...{
                        formValues,
                        closeDialog,
                        handleInputChange,
                        handleChangePrice,
                        handleSelectValues,
                        validaciones,
                        loading,
                        sections,
                        formats,
                        changeSelect,
                        specimenOrigins,
                        subSections,
                        commercialLines,
                        specimens,
                        specimenProvenances,
                        typeTransports,
                        transports,
                        id_section,
                        id_format_sanitary,
                        id_subsection,
                        id_specimen_origin,
                        code,
                        alias,
                        name,
                        abbreviation,
                        individual_sale,
                        cost,
                        is_referenced,
                        print_new_page,
                        methodAction: saveCreate,
                        isImagenologyy,
                        use_antibiogram,
                    }}
                />
            ) : method === "update" ? (
                <UpdateExamMicrobiology
                    {...{
                        formValues,
                        closeDialog,
                        handleInputChange,
                        validaciones,
                        loading,
                        sections,
                        formats,
                        handleSelectValues,
                        changeSelect,
                        specimenOrigins,
                        subSections,
                        commercialLines,
                        specimens,
                        specimenProvenances,
                        transports,
                        id_section,
                        id_format_sanitary,
                        id_subsection,
                        id_specimen_origin,
                        code,
                        alias,
                        name,
                        abbreviation,
                        individual_sale,
                        is_referenced,
                        is_critic,
                        listExternalLaboratories,
                        examId,
                        getUpdateDefaultExternalLaboratory,
                        print_new_page,
                        methodAction: saveUpdate,
                        use_antibiogram,
                    }}
                />
            ) : (
                null
            )}
        </Dialog>
    )
}
